import React, { useState, useEffect, useRef } from "react";

import CustomiseModal from "../../components/pos/customise-modal";
import {
    tableAddOrdersApi,
    fetchGroupProducts,
    tableEditOrdersApi
} from "../../redux/apis/table-apis";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";
import { Link, useNavigate, useParams } from "react-router-dom";

const EditTableProducts = ({}) => {
    const navigate = useNavigate();
    const [refreshing, setRefreshing] = useState(true);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();
    const [table, setTable] = useState({});
    const [data, setData] = useState({});
    const [products, setProducts] = useState([]);

    const customiseModalRef = useRef(null);

    // increase qty
    const addToCart = (item) => {
        setProducts((prev) =>
            prev.map((p) => (p.id === item.id ? { ...p, qty: p.qty + 1 } : p))
        );
    };

    // decrease qty
    const removeFromCart = (item) => {
        setProducts((prev) =>
            prev.map((p) =>
                p.id === item.id ? { ...p, qty: Math.max(p.qty - 1, 0) } : p
            )
        );
    };

    const handleCustomisationSubmit = (itemId, value) => {
        if (!itemId) return;
        // update the cart with customisation

        setProducts((prev) =>
            prev.map((p) => (p.id === itemId ? { ...p, request: value } : p))
        );
    };
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setRefreshing(true);
        try {
            var res = await fetchGroupProducts({
                group_id: id,
            });

            console.log("res", res);
            
            if (res.status == 200) {
                successToast(res.data?.message);

                var resData = res.data.data;
                var productsArr = resData?.order_products?.map(p => ({ ...p, qty: p.qty || 1 })) || [];
                setProducts([...productsArr]);
                setData({...resData});
                setTable({...resData.table});

            } else {
                errorToast(res?.data?.message);
            }
        } catch (error) {
            console.error(error);
            errorToast(error);
        }
        setRefreshing(false);
    };

    const confirmItems = async () => {
        setLoading(true);
        const payload = {
            products:products,
            restaurant_table_id: table?.id || "",
            group_id: id || "",
        };

        try {
            var res = await tableEditOrdersApi(payload);
            if (res.status == 200) {
                successToast(res.data?.message);
                navigate(`/pos/table-details/${table?.id}`);
            } else {
                errorToast(res?.data?.message);
            }
        } catch (error) {
            console.error(error);
            errorToast(error);
        }
        setLoading(false);
    };

    const renderItem = (item) => {
        const qty = item?.qty || 0;
        const request = item?.request || "";

        return (
            <div
                key={item.id}
                className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 flex flex-col hover:shadow-md transition"
            >
                {item.photo && (
                    <img
                        src={item.photo}
                        alt={item.name}
                        className="w-full h-20 object-cover rounded-lg mb-3"
                    />
                )}

                <h3 className="text-base font-semibold text-gray-800">
                    {item.name}
                </h3>
                <p className="text-sm text-gray-600">₹{item.price}</p>

                {qty > 0 && (
                    <div className="mt-2 flex items-center gap-2">
                        <button
                            className="px-2 py-1 text-xs bg-indigo-600 text-white rounded"
                            onClick={() =>
                                customiseModalRef.current?.showDialog(
                                    item.id,
                                    request
                                )
                            }
                        >
                            Customise
                        </button>
                        {request && (
                            <p className="text-xs text-gray-500 truncate">
                                {request}
                            </p>
                        )}
                    </div>
                )}

                <div className="mt-3">
                    {qty === 0 ? (
                        <button
                            className="w-full bg-red-500 text-white py-2 rounded flex items-center justify-center gap-2"
                            onClick={() => addToCart(item)}
                        >
                            ➕ Add
                        </button>
                    ) : (
                        <div className="flex items-center justify-between bg-gray-50 rounded p-1">
                            <button
                                onClick={() => removeFromCart(item)}
                                className="px-3 py-1 bg-red-500 text-white rounded"
                            >
                                -
                            </button>
                            <span className="font-semibold text-gray-800">
                                {qty}
                            </span>
                            <button
                                onClick={() => addToCart(item)}
                                className="px-3 py-1 bg-green-500 text-white rounded"
                            >
                                +
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    if (refreshing) {
        return (
            <div className="h-[90vh] bg-white text-gray-800 flex flex-col">
                <p>loading</p>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 flex flex-col  ">
            <CustomiseModal
                ref={customiseModalRef}
                onSubmit={handleCustomisationSubmit}
            />

            {/* Header */}
            <div className="bg-white  text-gray-700 border-b p-4 flex items-center gap-3">
                <Link
                    to={`/pos/table-details/${table?.id}`}
                    className="p-2 rounded hover:bg-gray-100"
                >
                    ⬅
                </Link>
                <h2 className="text-lg font-bold">
                    {table?.name} : Edit Order Items
                </h2>
            </div>

            {/* Filters */}
            {/* Product Grid */}
            <div className="overflow-y-auto p-4 grid grid-cols-1 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4">
                {products.map((item) => renderItem(item))}
            </div>
            {/* Cart Section */}
           <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 border-t">
                                   <button
                        onClick={() => {
                            confirmItems();
                        }}
                        disabled={loading}
                        className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold"
                    >
                        {loading ? "Loading" : "Confirm Items"}
                    </button>
                </div>
        </div>
    );
};

export default EditTableProducts;
